import { render, staticRenderFns } from "./SearchSelect.vue?vue&type=template&id=ec2585ba&scoped=true&"
import script from "./SearchSelect.vue?vue&type=script&lang=js&"
export * from "./SearchSelect.vue?vue&type=script&lang=js&"
import style0 from "./SearchSelect.vue?vue&type=style&index=0&id=ec2585ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2585ba",
  null
  
)

export default component.exports